<template>
  <el-dialog :title="$t('siteBuild.vipUserInfoWidget.valueRule')" class="dialog-base" :visible.sync="visible"
    :width="$store.getters.isMobile ? '90%' : '400px'" custom-class="value-rule-dialog" append-to-body
    :close-on-click-modal="true">
    <div class="rule-content">
      <div class="description">
        {{ $t('siteBuild.vipUserInfoWidget.valueRuleDesc', { growthName: $store.getters.projectGrowthValueName }) }}
      </div>
      <el-table v-imloading="loading" :data="tableData" class="rule-table" :border="true"
        :header-cell-style="{ textAlign: 'center', background: '#fafafa', color: '#333', fontWeight: 'bold' }"
        :cell-style="{ textAlign: 'center', color: '#333' }">
        <el-table-column prop="currency" :label="$t('siteBuild.currency')"></el-table-column>
        <el-table-column prop="price" :label="$t('siteBuild.price')"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog, Table, TableColumn, Message } from 'element-ui';
export default {
  name: 'ValueRuleDialog',
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      visible: false,
      loading: false,
      tableData: []
    }
  },
  methods: {
    open() {
      this.visible = true
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.projectMember.getGrowthPriceList({
        project_id: this.$store.getters.projectId
      }))
      this.loading = false
      if (err) {
        Message.error(err)
        return
      }
      this.tableData = res?.data || []
    }
  }
}
</script>

<style lang="less">
@import '../../../widgets/common/dialogBase.less';

.value-rule-dialog {
  .el-dialog__header {
    text-align: center;
    padding: 20px 20px 10px;

    .el-dialog__title {
      font-weight: 600;
      font-size: 18px;
      color: #333;
    }
  }

  .el-dialog__body {
    padding: 10px 20px 30px;
  }

  .rule-content {
    font-size: 14px;
    color: #333;

    .description {
      margin-bottom: 20px;
      line-height: 1.5;
      color: #333;
    }

    .rule-table {
      border-radius: 8px;
      overflow: hidden;
      font-size: 12px;
    }
  }
}
</style>
